export type FlagExposure = {
  flagKey: string;
  value: boolean | string;
  variant?: string;
};

export type TelemetrySink = {
  trackFlagExposure( exposure: FlagExposure ): void;
};

export const createNoopTelemetrySink = (): TelemetrySink => ({
  trackFlagExposure: () => {}
});

type PosthogLikeClient = {
  capture( event: string, properties?: Record<string, unknown> ): void;
  __loaded?: boolean;
};

export const createPosthogTelemetrySink = ( client: PosthogLikeClient ): TelemetrySink => ({
  trackFlagExposure({ flagKey, value, variant }) {
    // posthog-js exposes __loaded:boolean; skip only when explicitly false.
    // posthog-react-native has no __loaded (undefined) -> proceeds.
    if ( client.__loaded === false ) return;
    const properties: Record<string, unknown> = {
      $feature_flag: flagKey,
      $feature_flag_response: value
    };
    if ( variant !== undefined ) properties.$feature_flag_variant = variant;
    client.capture( '$feature_flag_called', properties );
  }
});
